interface TagProps {
  tagType: string;
  isActive: boolean;
  onHover: () => void;
  pending?: boolean;
}

export const Tag = ({ tagType, isActive, onHover, pending }: TagProps) => {
  const roles = {
    owner: 'OWNER',
    resource_op: 'RESOURCE OPERATOR',
    dataset_admin: 'DATASET ADMIN',
    sp_admin: 'SHARING PROFILE ADMIN',
    user_admin: 'USER ADMIN',
    trusted_sub: 'TRUSTED SUBJECT',
    member: 'MEMBER',
    editor: 'EDITOR',
    viewer: 'VIEWER',
  } as const;

  const roleColors = {
    owner: '#953C3E',
    resource_op: '#4E8C4E',
    dataset_admin: '#334151',
    sp_admin: '#719FA3',
    user_admin: '#806B89',
    trusted_sub: '#6B7789',
    member: '#6B7789',
    editor: '#4E8C4E',
    viewer: '#719FA3',
  } as const;

  const roleSizes = {
    owner: '70px',
    resource_op: '137px',
    dataset_admin: '115px',
    sp_admin: '200px',
    user_admin: '100px',
    trusted_sub: '115px',
    member: '70px',
    editor: '70px',
    viewer: '70px',
  } as const;

  const color = roleColors[tagType as keyof typeof roleColors];
  const size = roleSizes[tagType as keyof typeof roleSizes];

  return (
    <div
      className="relative h-6 flex items-center justify-center rounded-xs transition-[width] duration-500 ease-in-out"
      style={{
        backgroundColor: pending ? '#908F92' : color,
        width: isActive ? size : '20px',
      }}
      onMouseOver={onHover}
      onFocus={onHover}
    >
      <span
        className={`
          absolute
          font-normal text-xs
          px-[15px]
          transition-all
          duration-400
          ease-in-out
          whitespace-nowrap
          ${isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
        `}
        style={{
          display: isActive ? 'block' : 'none',
          color: isActive ? 'white' : 'transparent',
        }}
      >
        {roles[tagType as keyof typeof roles]}
      </span>
    </div>
  );
};
